import React from 'react';
import {errorBoundaryWrapper, isMicrosoftType} from "@repo/utils";

interface FileViewerProps {
    url: string | undefined;
    previewFileType: string | undefined;
}

/**
 * Renders an inline preview of a file based on its mime type, delegating to an Office-online iframe, PDF iframe, or plain image viewer as appropriate.
 *
 * @param url - URL of the file to preview.
 * @param previewFileType - MIME type used to select the appropriate viewer.
 */
const FileViewer = ({url, previewFileType}:FileViewerProps) => {
    const ImageViewer = ({ url }: { url: string }) => {
        return <img alt='example' style={{ width: '100%' }} src={url} />;
    };
    const OfficeViewer = ({ url }: { url: string }) => {
        return (
            <iframe
                src={`https://view.officeapps.live.com/op/embed.aspx?src=${url}`}
                style={{ width: '100%', height: '700px' }}
            />
        );
    };
    const PdfViewer = ({ url }: { url: string }) => {
        return <iframe src={url} style={{ width: '100%', height: '700px' }} />;
    };
    const GifViewer = ({ url }: { url: string }) => <PdfViewer url={url} />;
    const DocViewer = ({ url, mimeType }: { url: string | undefined; mimeType: string | undefined }) => {
        if (!url) return null;
        if (mimeType && isMicrosoftType(mimeType)) return <OfficeViewer url={url} />;
        if (mimeType == 'application/pdf') return <PdfViewer url={url} />;
        else return <ImageViewer url={url} />;
    };

    return <DocViewer url={url} mimeType={previewFileType} />
};

export default errorBoundaryWrapper(FileViewer);
